import React, { Component } from 'react'
import { connect } from 'react-redux'
import { func, node, arrayOf, object, string } from 'prop-types'
import Portal from 'react-portal'
import './PopUp.scss'

import Close from './assets/close.svg'
import ContactUs from './ContactUs'
import { changePopup } from '../../modules/Main'
import getScreenWidth from '../../utils/getScreenWidth'

export const PseudoModal = props => (
  <div>
    <div className='popup__wrapper green'>
      {props.children}
      <a onClick={props.closePortal} className='close'><img src={Close} className='img__full' alt='' /></a>
    </div>
    <div onClick={props.closePortal} className='active__overlay__overheader black' />
  </div>
)

PseudoModal.propTypes = {
  children: node.isRequired,
  closePortal: func,
}

PseudoModal.defaultProps = {
  closePortal: () => {},
}

class SectionPopUp extends Component {
  openSheets = (dom) => {
    setTimeout(() => {
      dom.getElementsByClassName('active__overlay__overheader')[0].classList.add('animate')
    }, 250)
    setTimeout(() => {
      dom.getElementsByClassName('popup__wrapper')[0].classList.add('animate')
    }, 350)
  }

  closeSheets = (dom, remove) => {
    dom.getElementsByClassName('popup__wrapper')[0].classList.remove('animate')
    setTimeout(() => {
      dom.getElementsByClassName('active__overlay__overheader')[0].classList.remove('animate')
    }, 100)
    setTimeout(() => {
      remove()
      this.props.changePopup('login')
    }, 250)
  }
  render() {
    const { section, children } = this.props
    const width = getScreenWidth()
    const isDesktop = width >= 768

    return (
      <Portal
        onOpen={dom => this.openSheets(dom)}
        beforeClose={(dom, remove) => this.closeSheets(dom, remove)}
        closeOnEsc
        openByClickOn={children}>
        <PseudoModal>
          { isDesktop ? (<div className='popup__subwrapper'>
            <div className='popup__subwrapper__left green'>
              <div className='section__popup'>
                <h1>Hubungi Kami</h1>
                <h4>Masukan dan pertanyaan anda membuat kami menjadi lebih baik</h4>
                <h6>Customer Care</h6>
                <p>halo@minapoli.com</p>
                <p>+62 811 1138 168</p>
                <p>Jam Operasional 08.00 - 18.00 WIB</p>
                <h6>Our Office</h6>
                <ul className='list-unstyled'>
                  <li><p>PT. Inovasi Perikanan Nusantara</p></li>
                  <li><p>DBS Bank Tower Lt. 28</p></li>
                  <li><p>Ciputra World One</p></li>
                  <li><p>Jl. Prof. Dr. Satrio Kav 3-5</p></li>
                  <li><p>Jakarta Selatan 12940</p></li>
                </ul>
              </div>
            </div>
            <div className='popup__subwrapper__right'>
              {section === 'contactus' && <ContactUs />}
            </div>
          </div>) : (<div className='popup__subwrapper'>
            <div className='popup__subwrapper__right popup__subwrapper__right--full'>
              {section === 'contactus' && <ContactUs />}
            </div>
          </div>
          )}
        </PseudoModal>
      </Portal>
    )
  }
}

SectionPopUp.defaultProps = {
  sliderContent: [],
  customClass: '',
  section: '',
}

SectionPopUp.propTypes = {
  sliderContent: arrayOf(object),
  popupSection: string.isRequired,
  customClass: string,
  section: string,
  changePopup: func.isRequired,
  children: node.isRequired,
}

const mapStateToProps = state => ({
  popupSection: state.main.popUp,
})

export default connect(
  mapStateToProps,
  { changePopup },
)(SectionPopUp)




// WEBPACK FOOTER //
// ./src/common/Modals/SectionPopUp.js